import React, { createContext, useMemo } from 'react';
export const ErrorMonitorContext = createContext(null);
export const ErrorMonitorConsumer = ErrorMonitorContext.Consumer;
export const ErrorMonitorProvider = ({ errorMonitor, children, }) => {
    const value = useMemo(() => ({ errorMonitor }), [errorMonitor]);
    return (React.createElement(ErrorMonitorContext.Provider, { value: value.errorMonitor, children: children }));
};
//# sourceMappingURL=ErrorMonitorProvider.js.map